/**
 * useCartDrawer Hook - Manage cart drawer open/close state
 */
import { useState, useCallback } from 'react';

export function useCartDrawer() {
  const [isOpen, setIsOpen] = useState(false);

  const openCart = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeCart = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggleCart = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  return {
    isOpen,
    openCart,
    closeCart,
    toggleCart,
    setIsOpen
  };
}
